
import React from 'react';
import { partners } from './data/partnersData';
import LogoCarousel from './LogoCarousel';

const PartnersSection: React.FC = () => {
  return (
    <div className="mt-16 pt-8 border-t border-gray-100">
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gradient">
        Nuestros Partners
      </h3>
      <div className="w-full overflow-hidden">
        <LogoCarousel 
          clients={partners} 
          grayscale={true} 
          speed={4}
          direction="left" 
          className="py-4"
        />
      </div>
    </div>
  );
};

export default PartnersSection;
